import { call, put, takeLatest, select, debounce } from 'redux-saga/effects';

import Const, {
  START_END_DATE_TIME,
  TEST_STATUS_ARRAY as _TEST_STATUS_ARRAY,
} from 'constant/Const';
import ApiManager from 'network/ApiManager/ApiManager';

import { EcgTestListInitialState } from './ecgTestListDuckType';
import { EcgTest } from 'type/apiDataType';
import { Nullable } from 'type/commonType';

import { getEcgTestSucceed } from 'redux/duck/testResultDuck';

const {
  FETCH_TYPE: { SEARCH_MODE, FETCH_MODE },
} = Const;
const TEST_STATUS_ARRAY = _TEST_STATUS_ARRAY;
const SELECTED_START_END_DATE_TIME = 'selectedStartEndDateTime';

// Selector
// Actions
// InitialState
// Reducer
// Action Creators
// Saga functions
// Saga

// Selector
export const selectSidePanel = ({ ecgTestListReducer }) =>
  ecgTestListReducer.sidePanel;
export const selectPatchState = ({ ecgTestListReducer }) =>
  ecgTestListReducer.patch;
const selectTableFilterOptions = ({ ecgTestListReducer }) =>
  ecgTestListReducer.fetch.tableFilterOptions;
// Action
// Create
const CREATE_ECG_TEST_REQUESTED =
  'memo-web/ecg-test-list/CREATE_ECG_TEST_REQUESTED';
const CREATE_ECG_TEST_SUCCEED =
  'memo-web/ecg-test-list/CREATE_ECG_TEST_SUCCEED';
const CREATE_ECG_TEST_FAILED = 'memo-web/ecg-test-list/CREATE_ECG_TEST_FAILED';
// Fetch ECG Test List
const FETCH_ECG_TEST_LIST_REQUESTED =
  'memo-web/ecg-tests/FETCH_ECG_TEST_LIST_REQUESTED';
const FETCH_ECG_TEST_LIST_SUCCEED =
  'memo-web/ecg-tests/FETCH_ECG_TEST_LIST_SUCCEED';
const FETCH_ECG_TEST_LIST_FAILED =
  'memo-web/ecg-tests/FETCH_ECG_TEST_LIST_FAILED';
// Patch
const PATCH_ECG_TEST_REQUESTED =
  'memo-web/ecg-test-list/PATCH_ECG_TEST_REQUESTED';
const PATCH_ECG_TEST_SUCCEED = 'memo-web/ecg-test-list/PATCH_ECG_TEST_SUCCEED';
const PATCH_ECG_TEST_FAILED = 'memo-web/ecg-test-list/PATCH_ECG_TEST_FAILED';
// Revert ECG Test Status CUSTOMER_CONFIRMED to CLOUD_CONFIRMED
const REVERT_STATUS_REQUESTED =
  'memo-web/ecg-test-list/REVERT_STATUS_REQUESTED';
const REVERT_STATUS_SUCCEED = 'memo-web/ecg-test-list/REVERT_STATUS_SUCCEED';
const REVERT_STATUS_FAILED = 'memo-web/ecg-test-list/REVERT_STATUS_FAILED';
// Delete
const DELETE_ECG_TEST_REQUESTED =
  'memo-web/ecg-test-list/DELETE_ECG_TEST_REQUESTED';
const DELETE_ECG_TEST_SUCCEED =
  'memo-web/ecg-test-list/DELETE_ECG_TEST_SUCCEED';
const DELETE_ECG_TEST_FAILED = 'memo-web/ecg-test-list/DELETE_ECG_TEST_FAILED';
// Return Device
const ECG_TEST_RETURN_DEVICE_REQUESTED =
  'memo-web/ecg-test-list/ECG_TEST_RETURN_DEVICE_REQUESTED';
const ECG_TEST_RETURN_DEVICE_SUCCEED =
  'memo-web/ecg-test-list/ECG_TEST_RETURN_DEVICE_SUCCEED';
const ECG_TEST_RETURN_DEVICE_FAILED =
  'memo-web/ecg-test-list/ECG_TEST_RETURN_DEVICE_FAILED';
// Confirm Review
const ECG_TEST_CONFIRM_REVIEW_REQUESTED =
  'memo-web/ecg-test-list/ECG_TEST_CONFIRM_REVIEW_REQUESTED';
const ECG_TEST_CONFIRM_REVIEW_SUCCEED =
  'memo-web/ecg-test-list/ECG_TEST_CONFIRM_REVIEW_SUCCEED';
const ECG_TEST_CONFIRM_REVIEW_FAILED =
  'memo-web/ecg-test-list/ECG_TEST_CONFIRM_REVIEW_FAILED';
// Edit Done Review
const ECG_TEST_EDIT_DONE_REVIEW_REQUESTED =
  'memo-web/ecgTest/ECG_TEST_EDIT_DONE_REVIEW_REQUESTED';
const ECG_TEST_EDIT_DONE_REVIEW_SUCCEED =
  'memo-web/ecgTest/ECG_TEST_EDIT_DONE_REVIEW_SUCCEED';
const ECG_TEST_EDIT_DONE_REVIEW_FAILED =
  'memo-web/ecgTest/ECG_TEST_EDIT_DONE_REVIEW_FAILED';
// get validReport latest value from ECG Test API
const GET_VALID_REPORT_REQUESTED =
  'memo-web/ecg-test-list/GET_VALID_REPORT_REQUESTED';
const GET_VALID_REPORT_SUCCEED =
  'memo-web/ecg-test-list/GET_VALID_REPORT_SUCCEED';
const GET_VALID_REPORT_FAILED =
  'memo-web/ecg-test-list/GET_VALID_REPORT_FAILED';

// reset table filter options
const RESET_TABLE_FILTER_OPTIONS =
  'memo-web/ecg-test-list/RESET_TABLE_FILTER_OPTIONS';

// show sidePanel
const SHOW_SIDE_PANEL = 'memo-web/ecg-test-list/SHOW_SIDE_PANEL';
const HIDE_SIDE_PANEL = 'memo-web/ecg-test-list/HIDE_SIDE_PANEL';
const SET_SIDE_PANEL_DATA = 'memo-web/ecg-test-list/SET_SIDE_PANEL_DATA';

// InitialState
const initialState: EcgTestListInitialState = {
  create: {
    pending: false,
    data: null,
    error: null,
  },
  fetch: {
    pending: false,
    data: [],
    error: null,
    // 검색, 필터링, 페이지 등의 옵션 값
    tableFilterOptions: {
      fetchType: FETCH_MODE, // 'fetchMode' | 'searchMode',
      firstPage: 1,
      page: 1,
      lastPage: null,
      totalCount: null,
      searchKeyword: '',
      ecgTestStatus: [],
      prescriptionDuration: [],
      selectedStartEndDateTime: {
        type: START_END_DATE_TIME.START_TIMESTAMP_MS_RANGE, //"startTimestampMsRange" || "endTimestampMsRange"
        startTimestampMsRange: [],
        endTimestampMsRange: [],
      },
      orderBy: '',
      isManuallyUpdated: false,
    },
  },
  patch: {
    pending: false,
    data: null,
    error: null,
  },
  revertStatus: {
    pending: false,
    error: null,
  },
  delete: {
    pending: false,
    data: null,
    error: null,
  },
  returnDevice: {
    pending: false,
    data: null,
    error: null,
  },
  confirm: {
    pending: false,
    data: null,
    error: null,
  },
  editDone: {
    pending: false,
    data: null,
    error: null,
  },
  validReport: {
    pending: false,
    data: false,
    error: null,
  },
  sidePanel: {
    isOpen: false,
    ecgTest: null,
  },
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Create
    case CREATE_ECG_TEST_REQUESTED:
      return {
        ...state,
        create: {
          ...state.create,
          pending: true,
          error: null,
        },
      };
    case CREATE_ECG_TEST_SUCCEED:
      return {
        ...state,
        create: {
          ...state.create,
          pending: false,
          data: action.data,
        },
      };
    case CREATE_ECG_TEST_FAILED:
      return {
        ...state,
        create: {
          ...state.create,
          pending: false,
          error: action.error,
        },
      };
    // Fetch Ecg Test List
    case FETCH_ECG_TEST_LIST_REQUESTED:
      const { type, ...actionPayload } = action;

      const tableFilterOptions = state.fetch.tableFilterOptions;
      const fetchDataLength = state.fetch.data.length;
      const newFetchType = fetchDataLength > 0 ? SEARCH_MODE : FETCH_MODE;

      return {
        ...state,
        fetch: {
          ...state.fetch,
          pending: true,
          error: null,
          tableFilterOptions: {
            ...tableFilterOptions,
            ...actionPayload,
            fetchType: newFetchType,
          },
        },
      };
    case FETCH_ECG_TEST_LIST_SUCCEED:
      return {
        ...state,
        fetch: {
          pending: false,
          data: action.data,
          error: null,
          tableFilterOptions: {
            ...state.fetch.tableFilterOptions,
            page: action.page,
            lastPage: action.lastPage,
            totalCount: action.totalCount,
          },
        },
      };
    case FETCH_ECG_TEST_LIST_FAILED:
      return {
        ...state,
        fetch: {
          ...state.fetch,
          pending: false,
          error: action.error,
        },
      };
    // Patch
    case PATCH_ECG_TEST_REQUESTED:
      return {
        ...state,
        patch: {
          ...state.patch,
          pending: true,
          error: null,
        },
      };
    case PATCH_ECG_TEST_SUCCEED:
      return {
        ...state,
        patch: {
          ...state.patch,
          pending: false,
          data: {
            ...state.patch.data,
            ...action.data,
          },
          error: null,
        },
      };
    case PATCH_ECG_TEST_FAILED:
      return {
        ...state,
        patch: {
          pending: false,
          error: action.error,
        },
      };
    // Revert ECG Test Status CUSTOMER_CONFIRMED to CLOUD_CONFIRMED
    case REVERT_STATUS_REQUESTED:
      return {
        ...state,
        revertStatus: {
          pending: true,
          error: null,
        },
      };
    case REVERT_STATUS_SUCCEED:
      return {
        ...state,
        patch: {
          ...state.patch,
          data: action.data,
        },
        revertStatus: {
          pending: false,
          error: null,
        },
      };
    case REVERT_STATUS_FAILED:
      return {
        ...state,
        revertStatus: {
          pending: false,
          error: action.error,
        },
      };
    // Delete
    case DELETE_ECG_TEST_REQUESTED:
      return {
        ...state,
        delete: {
          ...state.delete,
          pending: true,
          error: null,
        },
      };
    case DELETE_ECG_TEST_SUCCEED:
      return {
        ...state,
        delete: {
          ...state.delete,
          pending: false,
          data: action.data,
        },
      };
    case DELETE_ECG_TEST_FAILED:
      return {
        ...state,
        delete: {
          ...state.delete,
          pending: false,
          error: action.error,
        },
      };
    // Return Device
    case ECG_TEST_RETURN_DEVICE_REQUESTED:
      return {
        ...state,
        returnDevice: {
          ...state.returnDevice,
          pending: true,
          error: null,
        },
      };
    case ECG_TEST_RETURN_DEVICE_SUCCEED:
      return {
        ...state,
        returnDevice: {
          ...state.returnDevice,
          pending: false,
          data: action.data,
        },
      };
    case ECG_TEST_RETURN_DEVICE_FAILED:
      return {
        ...state,
        returnDevice: {
          ...state.returnDevice,
          pending: false,
          error: action.error,
        },
      };
    // Confirm Review
    case ECG_TEST_CONFIRM_REVIEW_REQUESTED:
      return {
        ...state,
        confirm: {
          ...state.confirm,
          pending: true,
          error: null,
        },
      };
    case ECG_TEST_CONFIRM_REVIEW_SUCCEED:
      return {
        ...state,
        confirm: {
          ...state.confirm,
          pending: false,
          data: action.data,
        },
      };
    case ECG_TEST_CONFIRM_REVIEW_FAILED:
      return {
        ...state,
        confirm: {
          ...state.confirm,
          pending: false,
          error: action.error,
        },
      };
    // Edit Done Review
    case ECG_TEST_EDIT_DONE_REVIEW_REQUESTED:
      return {
        ...state,
        editDone: {
          pending: true,
          error: null,
        },
      };
    case ECG_TEST_EDIT_DONE_REVIEW_SUCCEED:
      return {
        ...state,
        editDone: {
          pending: false,
          data: action.data,
        },
      };
    case ECG_TEST_EDIT_DONE_REVIEW_FAILED:
      return {
        ...state,
        editDone: {
          pending: false,
          error: action.error,
        },
      };
    // get validReport latest value from ECG Test API
    case GET_VALID_REPORT_REQUESTED:
      return {
        ...state,
        validReport: {
          ...state.validReport,
          pending: true,
          data: false,
          error: null,
        },
      };
    case GET_VALID_REPORT_SUCCEED:
      return {
        ...state,
        validReport: {
          ...state.validReport,
          pending: false,
          data: action.data.summary.validReport,
        },
      };
    case GET_VALID_REPORT_FAILED:
      return {
        ...state,
        validReport: {
          ...state.validReport,
          pending: false,
          data: false,
          error: action.error,
        },
      };
    case RESET_TABLE_FILTER_OPTIONS:
      return {
        ...state,
        fetch: {
          pending: true,
          data: [],
          error: null,
          tableFilterOptions: initialState.fetch.tableFilterOptions,
        },
      };
    case SHOW_SIDE_PANEL:
      const { ecgTestId } = action;
      let ecgTest: Nullable<EcgTest> = null;
      if (ecgTestId) {
        // 찾지 못했을 경우 undefined가 반환되는데, ecgTest의 타입은 Nullable이므로 null을 넣어준다.
        const foundEcgTest = state.fetch.data.find(
          (item) => item.tid === ecgTestId
        );
        ecgTest = foundEcgTest || null;
      }
      return {
        ...state,
        sidePanel: {
          isOpen: true,
          ecgTest: ecgTest,
        },
      };
    case HIDE_SIDE_PANEL:
      return {
        ...state,
        sidePanel: {
          isOpen: false,
          ecgTest: null,
        },
      };
    case SET_SIDE_PANEL_DATA:
      return {
        ...state,
        sidePanel: {
          ...state.sidePanel,
          ecgTest: action.ecgTest,
        },
      };
    default:
      return state;
  }
}

// Action Creators
// Create
export function createEcgTestRequested({
  patientName,
  patientNumber,
  patientSex,
  patientPhoneNumber,
  patientBirth,
  prescriptionDuration,
  pacemaker,
  referredBy,
  note,
}) {
  return {
    type: CREATE_ECG_TEST_REQUESTED,
    patientName,
    patientNumber,
    patientSex,
    patientPhoneNumber,
    patientBirth,
    prescriptionDuration,
    pacemaker,
    referredBy,
    note,
  };
}
function createEcgTestSucceed(data) {
  return {
    type: CREATE_ECG_TEST_SUCCEED,
    data: data,
  };
}
function createEcgTestFailed(error) {
  return {
    type: CREATE_ECG_TEST_FAILED,
    error: error,
  };
}
// Fetch Ecg Test List
export function fetchEcgTestsRequested({
  ecgTestStatus,
  prescriptionDuration,
  page,
  orderBy,
  searchKeyword,
  selectedStartEndDateTime,
}) {
  return {
    type: FETCH_ECG_TEST_LIST_REQUESTED,
    ..._removeUndefinedProperties({
      ecgTestStatus,
      prescriptionDuration,
      page,
      orderBy,
      searchKeyword,
      selectedStartEndDateTime,
    }),
  };
  // inner utility function
  function _removeUndefinedProperties(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      // Ignore undefined values
      if (value === undefined) return acc;

      // Handle the special case for SELECTED_START_END_DATE_TIME
      if (key === SELECTED_START_END_DATE_TIME) {
        acc[key] = {
          type: value?.[START_END_DATE_TIME.TYPE],
          startTimestampMsRange:
            value?.[START_END_DATE_TIME.START_TIMESTAMP_MS_RANGE] || [],
          endTimestampMsRange:
            value?.[START_END_DATE_TIME.END_TIMESTAMP_MS_RANGE] || [],
        };
        return acc;
      }

      // For all other cases, just assign the value
      acc[key] = value;
      return acc;
    }, {});
  }
}
export function fetchEcgTestsSucceed({ page, lastPage, totalCount, data }) {
  return {
    type: FETCH_ECG_TEST_LIST_SUCCEED,
    page,
    lastPage,
    totalCount,
    data,
  };
}
export function fetchEcgTestsFailed(error) {
  return { type: FETCH_ECG_TEST_LIST_FAILED, error };
}
// Patch
export function patchEcgTestRequested({ ecgTestId, form, callback }) {
  return {
    type: PATCH_ECG_TEST_REQUESTED,
    ecgTestId,
    form,
    callback,
  };
}
function patchEcgTestSucceed(data) {
  return {
    type: PATCH_ECG_TEST_SUCCEED,
    data,
  };
}
function patchEcgTestFailed(error) {
  return {
    type: PATCH_ECG_TEST_FAILED,
    error,
  };
}
// Revert ECG Test Status CUSTOMER_CONFIRMED to CLOUD_CONFIRMED
export function revertStatusRequested({ ecgTestId, callback }) {
  return {
    type: REVERT_STATUS_REQUESTED,
    ecgTestId,
    callback,
  };
}
function revertStatusSucceed(data) {
  return {
    type: REVERT_STATUS_SUCCEED,
    data,
  };
}
function revertStatusFailed(error) {
  return {
    type: REVERT_STATUS_FAILED,
    error: error,
  };
}
// Delete
export function deleteEcgTestRequested({ ecgTestId }) {
  return {
    type: DELETE_ECG_TEST_REQUESTED,
    ecgTestId,
  };
}
export function deleteEcgTestSucceed(data) {
  return {
    type: DELETE_ECG_TEST_SUCCEED,
    data,
  };
}
export function deleteEcgTestFailed(error) {
  return {
    type: DELETE_ECG_TEST_FAILED,
    error,
  };
}
// Return Device
export function ecgTestReturnDeviceRequested({ ecgTestId }) {
  return {
    type: ECG_TEST_RETURN_DEVICE_REQUESTED,
    ecgTestId,
  };
}
export function ecgTestReturnDeviceSucceed(data) {
  return {
    type: ECG_TEST_RETURN_DEVICE_SUCCEED,
    data,
  };
}
export function ecgTestReturnDeviceFailed(error) {
  return {
    type: ECG_TEST_RETURN_DEVICE_FAILED,
    error,
  };
}
// Confirm Review
export function confirmEcgTestReviewRequested({
  ecgTestId,
  reGenerateReport,
  callback,
}) {
  return {
    type: ECG_TEST_CONFIRM_REVIEW_REQUESTED,
    ecgTestId,
    reGenerateReport,
    callback,
  };
}
function confirmEcgTestReviewSucceed(data) {
  return {
    type: ECG_TEST_CONFIRM_REVIEW_SUCCEED,
    data,
  };
}
function confirmEcgTestReviewFailed(error) {
  return {
    type: ECG_TEST_CONFIRM_REVIEW_FAILED,
    error,
  };
}
// Edit Done Review
export function editDoneEcgTestReviewRequested({ ecgTestId }) {
  return { type: ECG_TEST_EDIT_DONE_REVIEW_REQUESTED, ecgTestId };
}
function editDoneEcgTestReviewSucceed(data) {
  return { type: ECG_TEST_EDIT_DONE_REVIEW_SUCCEED, data };
}
function editDoneEcgTestReviewFailed(error) {
  return { type: ECG_TEST_EDIT_DONE_REVIEW_FAILED, error };
}
// get validReport latest value from ECG Test API
export function getValidReportRequested({ ecgTestId }) {
  return {
    type: GET_VALID_REPORT_REQUESTED,
    ecgTestId,
  };
}
function getValidReportSucceed(data) {
  return {
    type: GET_VALID_REPORT_SUCCEED,
    data,
  };
}
function getValidReportFailed(error) {
  return { type: GET_VALID_REPORT_FAILED, error: error };
}

// reset table filter options
export function resetTableFilterOptions() {
  return {
    type: RESET_TABLE_FILTER_OPTIONS,
  };
}

// sidePanel actions
export function showSidePanel({ ecgTestId }) {
  return { type: SHOW_SIDE_PANEL, ecgTestId };
}
export function hideSidePanel() {
  return { type: HIDE_SIDE_PANEL };
}
function _setSidePanelData({ ecgTest }) {
  return { type: SET_SIDE_PANEL_DATA, ecgTest };
}

// Saga functions
function* _createEcgTest(action) {
  try {
    const {
      patientName,
      patientNumber,
      patientSex,
      patientPhoneNumber,
      patientBirth,
      prescriptionDuration,
      referredBy,
      confirmedBy,
      note,
      pacemaker,
      callback,
    } = action;

    const { data } = yield call(ApiManager.createEcgTest, {
      patientName,
      patientNumber,
      patientSex,
      patientPhoneNumber,
      patientBirth,
      prescriptionDuration,
      referredBy,
      confirmedBy,
      note,
      pacemaker,
      callback,
    });

    yield put(createEcgTestSucceed(data));
  } catch (error) {
    console.error(error);
    yield put(createEcgTestFailed(error));
  }
}

function* _fetchEcgTestList(action) {
  try {
    const {
      ecgTestStatus,
      prescriptionDuration,
      page,
      orderBy,
      searchKeyword,
      selectedStartEndDateTime,
    } = yield select(selectTableFilterOptions);

    const { data } = yield call(ApiManager.readEcgTests, {
      prescriptionDuration,
      page,
      orderBy,
      searchKeyword,
      selectedStartEndDateTime,
      ecgTestStatus: _combineValuesByKeys({
        statusArray: TEST_STATUS_ARRAY,
        targetStatusArray: ecgTestStatus,
      }),
    });

    const { count, results } = data;
    const pageSize = 100;
    const lastPage = Math.ceil(count / pageSize);

    yield put(
      fetchEcgTestsSucceed({
        page,
        lastPage,
        totalCount: count,
        data: results,
      })
    );

    // fetchEcgTests 성공시 url 업데이트
    _updateUrlWithParams({
      searchKeyword,
      ecgTestStatus: _combineValuesByKeys({
        statusArray: TEST_STATUS_ARRAY,
        targetStatusArray: ecgTestStatus,
      }),
      prescriptionDuration,
      orderBy,
      page,
      selectedStartEndDateTime,
    });
  } catch (error) {
    console.error(error);
    yield put(fetchEcgTestsFailed(error));
  }
  // inner util func
  function _combineValuesByKeys({ statusArray, targetStatusArray }) {
    return statusArray
      .filter((item) => targetStatusArray.includes(item.key))
      .map((item) => item.value)
      .flat();
  }
  function _updateUrlWithParams({
    searchKeyword,
    ecgTestStatus,
    prescriptionDuration,
    orderBy,
    page,
    selectedStartEndDateTime,
  }) {
    const queryParams = _convertToQueryParams({
      searchKeyword,
      ecgTestStatus,
      prescriptionDuration,
      orderBy,
      page,
      selectedStartEndDateTime,
    });

    window.history.pushState('', '', `?${queryParams}`);

    function _convertToQueryParams(obj) {
      const queryParams = new URLSearchParams();

      for (let key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        let value = obj[key];

        if (key === SELECTED_START_END_DATE_TIME) {
          value = obj[key][obj[key].type].map((dateTime) =>
            Date.parse(dateTime)
          );
          key = obj[key].type;
        }

        // 값이 없는 경우 무시
        if (
          value === null ||
          value === undefined ||
          value === '' ||
          value.length === 0
        ) {
          continue;
        }

        // 값이 배열인 경우, 콤마로 구분된 문자열로 변환
        const stringValue = Array.isArray(value) ? value.join(',') : value;
        queryParams.set(key, stringValue);
      }

      return queryParams;
    }
  }
}

function* _patchEcgTest(action) {
  try {
    const { isOpen } = yield select(selectSidePanel);

    const { ecgTestId, form, callback } = action;

    const { data } = yield call(ApiManager.patchEcgTest, {
      ecgTestId,
      body: form,
      callback,
    });

    if (isOpen) yield put(_setSidePanelData({ ecgTest: data.result }));
    yield put(patchEcgTestSucceed(data.result));
    yield put(
      getEcgTestSucceed({ ...data.result, summary: data.result.latestReport })
    );
  } catch (error) {
    console.error(error);
    yield put(patchEcgTestFailed(error));
  }
}

function* _revertStatus(action) {
  try {
    const { ecgTestId, callback } = action;

    const { data } = yield call(ApiManager.patchRevertStatus, {
      ecgTestId,
      callback,
    });

    yield put(getEcgTestSucceed(data.result));
    yield put(revertStatusSucceed(data.result));
  } catch (error) {
    console.error(error);
    yield put(revertStatusFailed(error));
  }
}

function* _deleteEcgTest(action) {
  try {
    const { ecgTestId } = action;
    const { data } = yield call(ApiManager.deleteEcgTest, {
      ecgTestId,
    });

    yield put(deleteEcgTestSucceed(data));
  } catch (error) {
    console.error(error);
    yield put(deleteEcgTestFailed(error));
  }
}

function* _ecgTestReturnDevice(action) {
  try {
    const { ecgTestId } = action;
    const { data } = yield call(ApiManager.ecgTestReturnDevice, { ecgTestId });

    yield put(ecgTestReturnDeviceSucceed(data));
  } catch (error) {
    console.error(error);
    yield put(ecgTestReturnDeviceFailed(error));
  }
}

function* _ecgTestConfirmReview(action) {
  try {
    const { ecgTestId } = action;
    const { data } = yield call(ApiManager.ecgTestConfirmReview, { ecgTestId });

    yield put(confirmEcgTestReviewSucceed(data));
  } catch (error) {
    console.error(error);
    yield put(confirmEcgTestReviewFailed(error));
  }
}

function* _ecgTestEditDoneReview(action) {
  try {
    const { ecgTestId } = action;
    const { data: editDoneData } = yield call(
      ApiManager.ecgTestEditDoneReview,
      { ecgTestId }
    );
    const { result } = editDoneData;

    yield put(editDoneEcgTestReviewSucceed(result));
  } catch (error) {
    console.error(error);
    yield put(editDoneEcgTestReviewFailed(error));
  }
}

function* _getValidReport(action) {
  try {
    const { ecgTestId } = action;
    const { data } = yield call(ApiManager.readEcgTest, {
      ecgTestId,
    });

    yield put(getValidReportSucceed(data.result));
  } catch (error) {
    console.error(error);
    yield put(getValidReportFailed(error));
  }
}

// Saga
export function* saga() {
  // Ecg Test List Read
  yield takeLatest(FETCH_ECG_TEST_LIST_REQUESTED, _fetchEcgTestList);
  // Ecg Test Create, Patch, Delete
  yield takeLatest(CREATE_ECG_TEST_REQUESTED, _createEcgTest);
  yield takeLatest(PATCH_ECG_TEST_REQUESTED, _patchEcgTest);
  yield takeLatest(DELETE_ECG_TEST_REQUESTED, _deleteEcgTest);
  // ecgTestStatus, cloudStatus
  yield takeLatest(REVERT_STATUS_REQUESTED, _revertStatus);
  yield takeLatest(ECG_TEST_CONFIRM_REVIEW_REQUESTED, _ecgTestConfirmReview);
  yield takeLatest(ECG_TEST_EDIT_DONE_REVIEW_REQUESTED, _ecgTestEditDoneReview);
  // fetch tableList when set tableFilterOptions
  yield takeLatest(RESET_TABLE_FILTER_OPTIONS, _fetchEcgTestList);
  // etc
  yield takeLatest(GET_VALID_REPORT_REQUESTED, _getValidReport);
  yield takeLatest(ECG_TEST_RETURN_DEVICE_REQUESTED, _ecgTestReturnDevice);
}
